module.exports = __webpack_public_path__ + "img/titleForLogoSlider.c7f7fc4.png";